import { ElMessage } from 'element-plus';

export function openSuccessMsg(msg: string) {
  ElMessage.success({ offset: 80, message: msg });
}
export function openErrorMsg(msg: string) {
  ElMessage.error({ offset: 80, message: msg });
}
